<template>
  <div class="agent-card">
    <div class="agent">
      <div class="agent-hero">
        <p>
          歡迎加入
          <span>iPastBook</span>
          合夥人
        </p>
      </div>
      <div class="agent-plane">
        <h4>合夥人獎勵</h4>
        <div class="text-center" v-if="!dataLoaded">
          <div class="loading-icon"></div>
          <p class="mt-1">載入中...</p>
        </div>
        <template v-else>
          <p v-for="(item, index) in rules" :key="index">
            粉絲下單累計滿{{item.symbol}}{{item.money}}，可返現{{item.rate}}%
          </p>
          <div>（運費不計入訂單金額）</div>
        </template>
        <div class="mt-1" v-if="isAvailable">
          <template v-if="isChecking || isApplying">
            <b class="text-primary">感謝您申請 iPastBook 合夥人，我們將於 48 小時內審核完成，請您耐心等待</b>
            <p class="mt-1" v-if="!isTalked">
              <a href="https://me.m/ipastbook">
                <button class="btn default btn-sm">咨询審核進度</button>
              </a>
            </p>
          </template>
          <button @click="applyAgent" :disabled="fetching" v-else
                  class="btn primary" :class="{'is-loading': fetching}">
            <i class="fa fa-spinner fa-spin" v-show="fetching"></i>
            申请成為合夥人
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from 'src/api'
import { mapGetters } from 'vuex'

export default {
  name: '',
  data: () => ({
    dataLoaded: false,
    fetching: false,
    isApplying: false,
    isChecking: false,
    isAvailable: false,
    isTalked: true,
    rules: []
  }),
  computed: {
    ...mapGetters(['user', 'locale'])
  },
  created () {
    this.fetchProfile()
  },
  methods: {
    // 申请代理
    applyAgent () {
      this.fetching = true
      api.applyAgentRequest().then(data => {
        this.fetching = false
        if (data.errors) {
          this.$toast({
            message: data.errors.message
          })
          return
        }
        this.isApplying = true
      }).catch(e => {
        this.fetching = false
      })
    },
    // 检查用户申请记录
    checkAgentApplied () {
      api.fetchAgentApply().then(data => {
        this.isAvailable = true
        this.isChecking = data.applied
      })
    },
    fetchProfile () {
      api.fetchUser(this.user.uid).then(data => {
        if (data.error) return
        if (!data.modifiedLocation) {
          this.fetchRules(this.locale)
        } else {
          this.fetchRules(data.countryCode)
        }
        this.isTalked = data.talked
        if (data.isAgent) {
          this.$router.replace('/agent/info')
        } else {
          this.checkAgentApplied()
        }
      })
    },
    fetchRules (countryCode) {
      api.fetchAgentRules(countryCode).then(data => {
        this.dataLoaded = true
        data = data.map(item => {
          item.rate = Math.round(item.rate * 100)
          return item
        })
        this.rules = data
      })
    }
  }
}
</script>

<style lang="scss">
.agent {
  & &-hero {
    height: 290px;
    padding-top: 30px;
    font-weight: 600;
    font-size: 24px;
    color: $el-color-primary;
    background: {
      image: url(../../../static/images/placeholder/agent-banner.jpg);
      repeat: no-repeat;
      position: center;
      size: cover;
    };

    span {
      color: transparent;
      white-space: nowrap;
      background: {
        repeat: no-repeat;
        position: center;
        image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAcIAAABkCAYAAAAVKjACAAAXgklEQVR4Xu1da3IURxLOannXI0Ybi0+wcAKLEyBOgDgBmPEGw/5BnABxAos/ZggzWJzAwwkQJ7A4gcUJrIllWBiYzo3qaeHRqOvZ1e9v/hCEqqorv8qsrx5ZmYLwAwJAAAgAASDQYQREh2WH6EAACAABIAAECEQIJQACQAAIAIFOIwAi7PTwQ3ggAASAABAAEUIHgAAQAAJAoNMIgAg7PfwQHggAASAABECE0AEgAASAABDoNAIgwk4PP4QHAkAACAABLyL874/DnSim6+vwxRG9+cfz0VEWrKo6VQ0BC3GyEdOJ/P5H/vbtd4cHp1X1Bd8tD4HZ3eGjrK/1X4wel9eLv75UF7tYtYfNX5++qQILfLP5CPhwQx2k9iLC2Y/DfWK6OKEIetx/PtrPEkxZpw4oJH1gSYRHTNHk8+LbVyDG2gxM0I7MBkPOJMLxyMsW8naunnYhbUFMmMQRbCHvCHervg831AEhL+P3EbaeBq8bAj4WRIefFpsvQYp1UNUwfQARuuLIp8TiYB73nsAOXLHrXnkfbqgDSiBC4yjwqSDavzR+9sRYFAVqjwCI0HeIloRY1RGyb69Rr1wEQIQS70YfjRoV5oRJ7G+Nn740lkSB2iIAIsw7NHw8X2zewO4wL47trA8ibD8RppqLiaDJJgwiDDF6fMrRxo2tX34+DtEa2mgPAiBCTyJkQW8EUaanaWHqwbTNgi4nXeaL3q/m72IiMGNUzxJNIcJS7SK1B8F0hYj+ZTdyfMosHm69GB3alUepLiAAIvQkQt1xalmK8787wyuLiHaEoF0iumn3XUwEdjjVq1RTiLAqu5C2wJHYZcF3iOh7/ehhQVgv7a6+NyDCBhPhuvq8vzu8IwTJZyDm1THTPhwIqjdA2x6ACG2RIrKzAz6dLzav4s7QHtc2lwQRtogIzxT1w937eyxYEuI/tcqrcRJqs9I3UTYQoduo/Xln7/LfNz4eENFtdU0+7o+fXXNrGaXbiACIsIVEKEWymwiImOkH3JfU37RBhH5jZHwHjMWgH7AtqwUibCkRru0Of9KsiuFJ1wCjBhH6D5KeDHFE6o9se2qCCFtOhFK82eD+LhFLLznFUSkmg7qbNIgw3wjNBkOp/9nHpNgV5gO3BbU7RYRJYFWinfVxi4mOVEG3mwrQuozv//2fbRHH8rmHigxxX1JjgwYR5huc9KpAvh/McCTDQjAfus2v3dR53ivEms9wNRWgLFnTneFvKhxwX+ijIeXUARHmxzn1Jv01qyXofn58m9xCU+d5EKGn1qUepao7w5P+eHTVs2lUKxABEGEYcGeDoUxhlvW86GV/PJJvEPHrIAIgQsOgNxUgnVi6+xLB4uGlF0+l2zl+NUIARBhmMNQLQT7tj599F+YraKVpCDR1nseOMIempfclcmWccV+I+5Ic0BZWFUQYBloZgSbeoD+yWosF3VD5CoT5OlqpKwIgwg7uCKXIOpdy7ArrZ64gwnBjojoeBRGGw7hpLYEIO0qECRkq70sQcaNuhgwiDDci738cHmUFrYfDTDiMm9YSiLDDRKjzopsvet8hDmN9zBlEGG4sZoPhJDNIPd4ThgO5YS2BCDtMhOmukLMgwOq4XpYMIgw3Hk2d9MIhgJbWEWiqTsBZJpAuK1fHRK/645FM74RfDRAAEYYbBOwIw2HZlpZAhB3fEcKdvBmmDCIMN06qO8KqcimGkwwt+SIAIuw4EercyXFP6GtW4euBCMNhOhsM5fMJmdX+3A9eo+EwblpLnSLCJNZoTNcvGEBEb9oea1SnmKpJtuiJQcY/3fjCyVvGWPC5GLARCxkXlRbfiOnWLz/LGJG1/Mk3mT3x6XuO4m1mcTlPJ3WJklVjRJwkYi7kF7fQLnQLv2hBVzcPR/J9bWm/NtiAC1h1lbdqIkxiQS/im0oshXjbHz+VTl7nfl53hD7C+tRxUYw6lJ0NhpJovi96hSwnId7gm5wEPheO9488EURHYiFelT1ZZY3R+8H92xHxnaUsYX798Uip10oiDPPp7FY0XpRNtQtNiMFpfzzKtZCxGYo22UCb5K1Sn5cBTv73mkhsKzCdRgvazpr3QIQ2WmhZpuh3VbO7w0ckeFcz0JY9PSvGx8RiottBOTZoXVwSoCCWu7ALR2vWjSgKggjzImiu/2EwfK1YvBTqHNYmGzCjTNQ0easkQo1OJlBzFF1TnYqBCG200bJMUV50RZJGKtoJk9jfGj99aSmqd7E0LJ0MVl5YYGYQoffwWFXUZV8p6rlQm2zABuSmylsVEc4GQ5kNRTmnmPQSRGijlZZlQitBchfLJAc4+K4pWyQ+joV4WFScSIujC0uk9cVAhEFgVDaicpIhouDHom2zAdPINF3e0HOgCS/5d0MmIGKiJ1vj0Z6uLRChDdKWZULuCJdHIsU5cGhFYtoPfVxaFglKuUCElgrrUUy78g4cUaZtNmCCuw3ylk2EptywZPmOG0Ro0k6Hv4e4I8xxdPiOBS099ZiW3qGCkktjwcmOMit3nE66w/mi9zBUeDjT0cVKRxI5pEOPA/Tnivafj5QeoEpnGUGPfb9nqhcTHbXBm1oXSlDuBueL3pUQ+tJWG1DpSZvkLZMIEw/ReCGdY1TOWW/ni96OjU6CCE2zmMPfVURo+3zCcdc0JaIjZpp8jnsT02DLtv8WfdwVgqSXqfTQzEgdtS4sH88XmzdMbZsgMkygy+qCHs+/9A7yfsvUF7wjNCGU/XfTGIbKtNJWG9CToNbTcbVq7W2+LCJMFw+/a66NnBZmIEK/eSGzVp53hOkE8IdmdXP2zalgsZ836W96ri53TgZCzJ9XUXOnJGV6y1F0p6w3jiBCd4W32M2/7Y9HKpd16w+22QayQGijvGUR4Wxw73fdMwmOoh2XOQVEaG2m+oJ5IstYroKnJOgg5K4p+e43H/eISV4kawjRf2douMgOMoG6DCGI0B4tS8cNp5V3zp1RI21AQ4K6N2+yWuPkLYMITQszk4do1niACO3nBW3JPA+MTQNLRO84inZdVjguYi3P2mMZbUF3j3jYH49+cGlXltWs3KauqzbXb2eVBxGaF3QyWIMM1GAT5MD22N80dm22AYUeat39m2rzRROhyUPUN84tiNBkoZZ/980+octwn37a+sLXsquZxdIzd+mgciEyztcKjl6BaZt/Zq7AWDzMe7zrI29TiFA6CzH7Oww5YSN4W5C4zMSXHYI1TGNBuyGe2rTZBjJJ8MfhPjE90oxRY22+SCI03VMT0cv+eOT1PhlE6DRjqAurJljdNj09enqt6YL3wPqKNRsMD4notqq+yw5AJ19VgcibQoS+41dSvWC7+bbbwPp4tF3eoogwpIcojkYLmiV8M9SbnEhCOCD4iKyKmbpsi4/742fXbNrVHGO8649HJQUJON9TEKHNyKnLsKA3G1/oTqg4tW23gXUk2y5vEURo4VT0br7obefxOMeOMN+8kNTWKLfSGcSwzc89sHnESo805VvEzDtD28tozZFXofEodbKDCP01Qx7XXhqPbvi3cL5mF2xgVeIuyBuaCC0cCYOcToAIc1q17n5D97ZKF6aqCieSdRhSBxp5Z5jlTXrSH4+umqDTYFP6ke9ZX0GEplHT/12S4adF71ae1ffKWGTmM5Tekm2xgVU0O23zjv4FKzpicCoSt7LSKrlqOYjQFbGV8oYtu9KtXOsc4KkwOcRQVs3bT3V9++PV0HKBCEMgyqccbdzI48WcV7dCSGHTRqh+hmrHps95yuTtZ8gdocmJKlQQB4kXiDCH1uhcvvW7QeVj0CBvsnKIdK5qekQqw7Zl7ArNZKY7CtLFAw3V/6x2mkKE8i4uT5g5JwyZtlnQZcEkQ1WpvYbPNZqPDHXPakKFanPCQFE4rw38tbPphs2HIsIiPUSzhhpE6GkthvcsSmcQ3cP7kCscT7EuVNPJacpErveQC3Ok4SpnU4jQ9z2UKx7r5ZOEt5HYjSPeFUzX9e35kWGXbEDi1yV5QxBhei0jw6epfsEDcYAIPWYOU8RznTNJnof3Hl0NUmU2GJ5m7QptiFtVV3qfhohj6iogiNAesVTPDwyBFk7mi941lzvDrtlAl+TNS4TLRQPL8Gm5A2nbazqORl2wSsravGfRPXvwfXjv3NGAFfL0WVNXPsWY9MfPbgXsqrEpEKERogsFTG9LXb1J8+iTe+/D1MjT5zx1w/TevRXfPuchwrI8RHE06q4P52osV8jxr5rVivGOz+fhfc5u566e567PtHuWZBgtxMNQ79JMwoIITQhl/90U2sr2SY1svXs2MOQsVF0w8xs1/1q+Np+HCGeDe7/J0H6qXrsE83CVHEejloh9GNx7wCTkMZHqZ3T51p19VxVpxUZ8Xag0jqJrJu9BVXqqtW8fchQ9MbVl019dGRChP4J6MrTLUtI1G+iavL5E+H4wPBBED1TaWfSiAURomBdsk2baDJTGeaSySCu206Lqrs9mlWZx+b3ajRMWPCGx8bIIUgQR2o54djntManF05+u2UDX5PUhwrI9RHE06jgHzO4OH5HgPWOOQIsJQH5aZRTSVX7r+Ugmy63tL2/SYQtlz5Cdj1nQUUhSBBHmV7HZYCif1GRFHTIGWuiaDXRNXlciNC2Sy5obsSPMmBfeD+7fFsQyaa05HqYlCSZ3I4qo82UNdp4pUHm86SC/Hxl+7fWJID74tNh86eKhuC4ziDCPFizr6sdR/yymazYAeVN9y5gnbBwP54veTh57t9V2EGH6zkfmYFvmX1Nf1q6BOmWmva0XI5mtweqnNAqiJ1vjkUyOW9uf8gzfgQiTSXSZ+1BiZvlwOxOSw2hBj30cbECEYVRMc++rjSPbNRuAvNlEaOMhGi1o28fGfTS8ciIsNe/aGUJp/jX5X5vkoxnAGh1jsgaja0ahU8h0VyF33bpkwHqdZtrvvxg9dlF8EKELWuqyascZPu2Pn32nqtk1G4C82UT4YTB8bZp7bfwuwmhzHd4RhpKkvHa8k2Z27ZjEZkjSOxSZTFOZA9HAhk4P80GENqNiLqOLlqKLONQ1G4C8F4lQF5pyXfPKIsPKd4Rmk6tNiXfMtO9yFLre8zZenIcKBSaPSv4WfdwVQh5Pk3xLlJX1QqEM9lFqQITh7EnlNKPzJG6jDUDev3TK5Czj4ydQBhmCCM3zwlSw2L/04qnuDaG5FY3XKBEZve2sPlBgodng3p+Z3rOOd4Q2XVwhRUmIN23q2EapARHaoWlTyseBSvOcoLE24EOETbZ5nbw6IoyJjiKm1za6VfbOEESoHpW3gsXhp/jbw1BeS218XBtqR6gahhVSNN4n2rxpBBH6TEPZdZRhuDSLozbagC6oRNfk1aROekXE13VRuUynQEXuDEGEf9n4lIiOmGnyOe5NQpHf+hTStvBSRRPhKn6pkUnvWsWxqTk1FIgwIBEqngOZdKJtNmBKKdYleU05BBXaN5UeovEGycWu1legKDKsnAhLzbu2Mgoc0wlHJB8G05cvveOiiC+DCCeK4z6t23m46cu9JW3g7AKORnU91Kd2IjKFfAMRuo+/qobPjlC25RvQOVzP3VvK0+c8dd17GqaGb599iHDVZk0B3on8Un+ZUKmcCE2rR5MATfu7r9t5lXIq7wdlp0omQvlJ3YW7KTUUiDCcJqnuCE2r9jbZgEnfJNpdkteVCLN0pQoyBBGGmxesWmpTks5E4AqIMN1VHGc9yjdF6QERWqmpVaHZYPhHVvQl011tm2zAlJxaAtkleV2IkDWBRMomQxChlcmHLTQbDDMncbntny82r5Z1TGuSKo3+8Ic21mpVRKi6nyL9PSGI0DTqdn/XTe4mItQtZBpmA9aZ0lti80Z5HYjQeBVUJhmCCO3sPmgprbJURCxZAlopdUX91eU51DkvgAjDqHLerOutsAEH3e+KvFZzBpF1UJKyyBBEGGZecG5FHcG/mMtg1w5aBMRdNukwGbj2QVdetyMBEYZEOrst1bEoEb3sj0cyUpDx13AbcE6d1gV5LYgw8RB1iSFaBhmCCI3mWkwBQ4SFk/mid62qI9I0B+PvobNvhERS5z0KIgyJ9MW2dLprcpRZba3JNuAi55nMXZDXRIQmr26V5hZNhiDCYucMbeuavG4yHPhxf/zsWhXdmw3u/U4ktq2+XdGOUDOpTPvj0WWNQXHW30xvwayw8ChkCknl0WShVQyLpOl80bvisoBrqA0Y78o0+qfK5Vhnm7eWV0eEPouHVRyLJEMQYaHThr5x05s4Ijrsj0c/lNlFl4C4Sb+qIsLB8EAQPVjHBl6jxWqLVj88dKGJNmDjDKQahbbLqyFC6yNznQYXRYYgwmLnDWPrpqMEuTOcLzZvuKyyjR/NKGCRHyy7WY/Jz6d/q3V0uxKdS7ZsA84y/ugbdNV5N3jWk0bZQAB9b7O8ZZxwFEGGIEL/eSFYTfPAyig40a2tX36Wzy6C/9J4iL9Z3Qmufz3AxOAq0Gxw7zdVAmXTah1E6Ir2svzs7vARiSQEViELoobYQJBdTbogk8mpdeHE6mDzzvKWQYR2+Lk5HYII/eaFoLXSHc6RPms7nxKLg3ncexJqd5h8N/r4gATvad8KEr1loqOso8iyj0Z1zyaISHs/iB2hu9qmuvkTEek8Qa3vkFQ9aIINzBe9naC2t/Gx1jbvI29ZRBiaDEGE7nNDITXSiUBepBvy8PGpINq/NH72JE9HPgzuPWCSK3yhdCxJ23/HUbQrON4lpkcXvlnijtC0K7G5jMeO0F5r3g/u3xbEchd4RVPL+0h0vc0a20AwGVdlbqO8ZRJhSDIEEdrPC4WXtFsVn3WDT5NsGRRNPi++fWVaqSbpjDY+3RQUyxx/OxYEKD/09eFr2Qq+CvbSwYB/MniyWr3rAhHq1Vi+z+QNvskkZJYPHQHKhqYcRTshj+zrbANFTABtk7eKecJ8rG4+JgURFqHdOdpMDUMmAdamI7n4CblTFMkdYiw4+Tfi5RMIJt62JL6vzUrvy89fertnBOuj4AmBxXTdCw4hJ+Gk3zbPOKwn5KYQoVimBJNHZ8X/BG8LEpd5SXwm8jvrz5SZ9rZejORdV9BfXWxABgeYL3p7pkVmXuHbJK/PPJEXvxA7QxBhiFEooA2zZ1kBHz1rMuO400fBy5NB3OqPn8r0VsZfU4jQKEi1BawXHnm6WZ7+ZPSyxCP/s6+3QV6feSKPjqzWzbMzBBGGGoUC2knfHMnd4fcFNJ/VZHIfmHXU5aPgZRi2zb3gmrE040F9SQPu8RnrOJEebV+oUoENvI0F7f3j+aic3fiaxE2X12eeCKEnXxcTg6HBGzf7mBREGHIUCmorjaIinRb+VdAn3jHTvu6Yy0fBCyZCr10JdoTeGjQlQQf95yP1Ewrvps0V62AD5l6GK9FUeX3miXCoLVvy2RmCCEOPQoHtpUomnV2C7BDlPSDFdGhzz+Oj4AUS4ctoQfsugXtXVozYEbrpaEKA8y+9g6Lvymy6FdoGpEMYCZpURfAmmZsmr888YcLA5++uZAgi9EG54jqJZ18kdlnwDhHddOjOlAUdR7GYiJgnLkTio+CBifCd9JL1JUAQoYOWEE2JaCKddT7HvUkdCHC99zlsQDb1SrA4crUBJwQDF26KvD7zRGCovjbnQoZeRJicYycu+Od/MdGR6mzdp05RALWtXRkZhjlO3gOuj4uIxeki4uNvvtCJC/GtY+Qzfqo6TvizOOZInIRy0U8MNeNX1Y4gCEZOgGYX5lhGLyL5jpWquh/LI4bOBuS8JNsWIjoNpUd5+hqibl3l9ZknQuChaiPJmxmx8q20nB8vvXgq4xbjBwSAABAAAkCguwiACLs79pAcCAABIAAEkiQ6+AEBIAAEgAAQ6DACIMIODz5EBwJAAAgAAewIoQNAAAgAASDQcQSwI+y4AkB8IAAEgEDXEQARdl0DID8QAAJAoOMIgAg7rgAQHwgAASDQdQRAhF3XAMgPBIAAEOg4AiDCjisAxAcCQAAIdB0BEGHXNQDyAwEgAAQ6jgCIsOMKAPGBABAAAl1HAETYdQ2A/EAACACBjiPwf32SuL5dU/79AAAAAElFTkSuQmCC);
        size: contain;
      };
    }
  }

  & &-plane {

  }
}
</style>
